import { handleRequest } from "../utilities/requestHandler";

export const getOptions = () => 
    handleRequest("get", "/options");

export const insertOptions = (req_body) => 
    handleRequest("post", "/options/insert", req_body);

export const getOptionsByKey = (optionKey) =>
    handleRequest("post", "/options/get-by-key", { option_key: optionKey });

export const uploadCompanyLogo = (formData) =>
    handleRequest("post", "/options/upload-logo", formData, { headers: { "Content-Type": "multipart/form-data" } });

export const getBrandingLogos = () =>
    handleRequest("get", "/options/branding/logos");

export const uploadCompanyBackdrop = (formData) =>
    handleRequest("post", "/options/upload-backdrop", formData, { headers: { "Content-Type": "multipart/form-data" } });

export const getBrandingBackdrops = () =>
    handleRequest("get", "/options/branding/backdrops");

export const getBrandingStockImages = () =>
    handleRequest("get", "/options/branding/stock-images");

export const deleteBrandingAsset = (assetPath) =>
    handleRequest("post", "/options/branding/delete", { path: assetPath });

export const uploadCompanyStockImage = (formData) =>
    handleRequest("post", "/options/upload-stock-image", formData, { headers: { "Content-Type": "multipart/form-data" } });
